import HC from "./compute";

export const MODE = "pbi"; // Power BI logic only (Corrected mode removed 12 Oct at HDFC request)
export const f2 = x => x === null || x === undefined || isNaN(x) ? "—" : (+x).toFixed(2);
export const fint = n => n === null || n === undefined ? "—" : Math.round(n).toLocaleString("en-IN");
export const IND_COLOR = { Relevance: "var(--c1)", Coherence: "var(--c2)", Efficiency: "var(--c3)", Effectiveness: "var(--c4)", Impact: "var(--c5)", Sustainability: "var(--c6)", Branding: "var(--c7)" };
export const BAND_COLOR = { Excellent: "var(--ex)", Good: "var(--gd)", Moderate: "var(--md)", Poor: "var(--pr)" };
export const BANDS = [["Excellent", "4.6–5.0"], ["Good", "3.6–4.5"], ["Moderate", "2.6–3.5"], ["Poor", "1.0–2.5"]];
export const BAND_RANK = { Excellent: 4, Good: 3, Moderate: 2, Poor: 1 };
export const bandM = x => HC.band(x, MODE);
export const uniq2 = a => [...new Set(a)].sort((x, y) => x.localeCompare(y));
export const rtip = r => ["v5", "v4", "v3", "v2", "v1"].map((k, i) => `${5 - i}: <span class='num'>${fint(r[k] || 0)}</span>`).join(" · ");

export const store = {
  get(k, d) { try { const v = localStorage.getItem("hdfc-" + k); return v === null ? d : v; } catch (e) { return d; } },
  set(k, v) { try { localStorage.setItem("hdfc-" + k, v); } catch (e) { } },
};
export const VALID_TABS = ["score", "activity", "links", "subs", "guide"];
